import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Cancellation() {
  return (
    <LegalPage
      title="Cancellation & Refund Policy"
      eyebrow="If your plans change"
      intro="Life happens. Our cancellation policy is designed to be fair to both you and the small partners (drivers, guides, family-run hotels) who reserve their time for your trip well in advance."
      seoDesc="Cancellation and refund policy for tours, transfers and bookings with Tour Trips India Holidays."
      sections={[
        {
          heading: "1. Cancellation by you",
          paragraphs: [
            "The cancellation charge depends on how far in advance you notify us in writing (email to info@ttiholidays.com or WhatsApp message — replied to and acknowledged by our team):",
            "• 60+ days before tour start: 95% refund (we retain 5% for payment-processing & admin costs).",
            "• 45 to 59 days before: 75% refund.",
            "• 30 to 44 days before: 50% refund.",
            "• 15 to 29 days before: 25% refund.",
            "• Less than 15 days before, no-show, or early departure: no refund.",
          ],
        },
        {
          heading: "2. Bookings with peak-period dates",
          paragraphs: [
            "Tours that overlap with peak windows — December 22 to January 5 (Christmas & New Year), Holi week, Diwali week, Pushkar fair dates, and any IPL cricket dates affecting Mumbai/Delhi/Jaipur hotels — have a stricter window: no refund within 45 days of tour start, as our hotel and transport partners require full advance payment for these dates.",
          ],
        },
        {
          heading: "3. Cancellation by us",
          paragraphs: [
            "If we cancel a tour for reasons within our control (e.g., over-booking on our side, an unfilled minimum-group requirement), you will receive a 100% refund OR the option to rebook on alternate dates at the same price.",
            "If we cancel due to force majeure (see Terms section 6), we will refund all amounts not already paid to non-recoverable suppliers and assist you in claiming the rest from your travel insurance.",
          ],
        },
        {
          heading: "4. How refunds are issued",
          paragraphs: [
            "Refunds are returned via the original payment method (bank transfer / UPI) within 7–10 working days of the cancellation confirmation, in the same currency as your original payment. Exchange-rate losses and bank fees are not refundable.",
          ],
        },
        {
          heading: "5. Promo codes & discounts",
          paragraphs: [
            "If a tour was booked with a promo code or seasonal discount, the refund is calculated on the discounted price actually paid, not on the original list price. Promo codes are not transferable to a future booking.",
          ],
        },
        {
          heading: "6. Travel insurance",
          paragraphs: [
            "We strongly recommend a comprehensive travel insurance policy that covers cancellation due to illness, family emergency, flight disruption, and trip interruption. Insurance is the most effective protection for non-refundable amounts.",
          ],
        },
        {
          heading: "7. Disputes",
          paragraphs: [
            "If you believe a refund has been incorrectly calculated, please email info@ttiholidays.com within 30 days of receiving the refund. We will respond and re-examine within 14 days.",
          ],
        },
      ]}
    />
  );
}
